---
title: Colophon
description: The design decisions, typefaces, and technical choices behind this site.
---

I always love knowing the choices behind things, so here are some of mine for this site you're on now.

## Typography
- [Andale Mono](https://learn.microsoft.com/en-us/typography/font-list/andale-mono): Monospace font used for headings, code and buttons
- [Inclusive Sans](https://fonts.google.com/specimen/Inclusive+Sans) for the rest. 

## Frameworks and tools
- [Tailwind CSS](https://tailwindcss.com) for styling. 
- [shadcn/ui](https://ui.shadcn.com) for accessible components built with Radix and Tailwind. 
- [Motion](https://motion.dev) for animations like the header and gallery. 
- [shadcn-prose](https://shadcntemplates.com/theme/haydenbleasel-shadcn-prose) for the MDX pages.

Other things
- Coded in [Cursor](https://cursor.com)
- Hosted on [Vercel](https://vercel.com)
- Tools and thoughts written in [MDX](https://mdxjs.com)
- Homepage, resume and photo gallery built with [TypeScript](https://www.typescriptlang.org) 

This website began as a prototype using [sandbox new](/tools/sandbox-new). 